import React from 'react';
import PropTypes from 'prop-types';

import ActivityToolboxActionGroup from './activity_toolbox_action_group.jsx';

export default class ActivityToolbox extends React.Component {
	static propTypes = {
		subtitle: PropTypes.string,
		processId: PropTypes.number,
		version: PropTypes.number,
		isMobile: PropTypes.bool,
		processIds: PropTypes.object,
		waitingForAction: PropTypes.bool,
		readOnly: PropTypes.bool,
		existHelpFile: PropTypes.bool
	};

	static defaultProps = {
		subtitle: '-',
		processIds: {},
		waitingForAction: false,
		readOnly: false,
		isMobile: false,
	};

	buildProcessDefinitionIds() {
		return {
			processId: this.props.processId,
			version: this.props.version
		};
	}

	render() {
		return (
			<div className={`activity-toolbox grey lighten-3 ${this.props.isMobile ?  'mobile' : ''} ${this.props.newWS ? 'newWS' : ''}`}  role="banner">
			<span title={this.props.subtitle} className="activity-toolbox__subtitle" tabIndex={this.props.subtitle && this.props.subtitle.trim().length > 0 ? 0 : -1} aria-label={this.props.subtitle} style={{margin: '0 0', fontSize: '1.2rem'}}>
			{this.props.subtitle}
			</span>

			<div className="activity-toolbox__actions">
			<ActivityToolboxActionGroup
			processIds={this.props.processIds}
			processDefinitionIds={this.buildProcessDefinitionIds()}
			waitingForAction={this.props.waitingForAction}
			readOnly={this.props.readOnly}
			existHelpFile={this.props.existHelpFile}
			isMobile={this.props.isMobile}
			/>
			</div>
			</div>
		);
	}

}
